import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
  OnChanges
} from '@angular/core';
import { DataService } from "./data.service";
import { PermissionUrlService } from "../../services/permissions.service"; //"./../../../shared/services/permissions.service";
import { from } from "rxjs";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'single-api-highlights',
  templateUrl: './single-api-highlights.component.html',
  styleUrls: ['./single-api-highlights.component.scss'],
  providers: [DataService]
})
export class SingleApiHighlightsComponent implements OnInit, OnChanges {
  private unsubscribe: Subject<void> = new Subject();
  dataLoading = false;
  @Input() PERMISSIONS = [];
  @Input() TITLES = [];
  @Input() API;
  @Input() TEXTS = [];
  @Input() CONFIG = null;
  @Input() FILTERS;
  dataSet = null;
  deviceWidth = window.innerWidth;
  columnSize;
  mockData = false;

  constructor(private WIDGET_PERMISSIONS: PermissionUrlService, private dataService: DataService) { }
  ngOnInit() {
   
  }

  ngOnChanges(){
    this.getData();
  }

  getData(){

    this.dataLoading = true;
    this.columnSize = this.CONFIG['columnSize'] ? this.CONFIG['columnSize'] : 6;
    this.dataSet = null;
    this.dataService.getData(this.API, this.FILTERS , this.CONFIG).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.dataLoading = false;
      this.mockData = false;
      if (res) {
        this.dataSet = res;
      }else{
        this.mockData = true;
      }
    }, error => {
      this.dataLoading = false;
      this.mockData = true;
    });
  }
}
